var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "nihao" }, [
    _c(
      "div",
      {
        staticStyle: {
          "font-size": "15px",
          "text-align": "center",
          "font-weight": "bold",
          padding: "12px",
          "border-bottom": "1px solid #e6e6e6"
        }
      },
      [_vm._v(" 聊天内容 ")]
    ),
    _c(
      "div",
      { staticClass: "category" },
      [
        _c(
          "el-tabs",
          {
            attrs: { type: "card", stretch: "" },
            model: {
              value: _vm.msgSort,
              callback: function($$v) {
                _vm.msgSort = $$v
              },
              expression: "msgSort"
            }
          },
          [
            _c("el-tab-pane", { attrs: { label: "全部", name: "text" } }),
            _c("el-tab-pane", { attrs: { label: "文件", name: "file" } }),
            _c("el-tab-pane", { attrs: { label: "图片", name: "image" } }),
            _c("el-tab-pane", { attrs: { label: "通话", name: "voice" } })
          ],
          1
        )
      ],
      1
    ),
    _c(
      "div",
      {
        staticClass: "chat-test",
        staticStyle: { height: "85%", width: "100%" }
      },
      [
        _c("normal-log", {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.msgSort == "text",
              expression: "msgSort == 'text'"
            }
          ],
          attrs: {
            data: _vm.recordContent,
            loading: _vm.loading,
            total: _vm.total,
            size: _vm.size,
            showMore: _vm.showMore
          },
          on: { loadMore: _vm.loadMore }
        }),
        _c("file-log", {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.msgSort == "file",
              expression: "msgSort == 'file'"
            }
          ],
          attrs: {
            data: _vm.recordContent,
            loading: _vm.loading,
            total: _vm.total,
            size: _vm.size,
            showMore: _vm.showMore
          },
          on: { loadMore: _vm.loadMore }
        }),
        _c("image-log", {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.msgSort == "image",
              expression: "msgSort == 'image'"
            }
          ],
          attrs: {
            data: _vm.recordContent,
            loading: _vm.loading,
            total: _vm.total,
            size: _vm.size,
            showMore: _vm.showMore
          },
          on: { loadMore: _vm.loadMore }
        }),
        _c("audio-log", {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.msgSort == "voice",
              expression: "msgSort == 'voice'"
            }
          ],
          attrs: {
            data: _vm.recordContent,
            loading: _vm.loading,
            total: _vm.total,
            size: _vm.size,
            showMore: _vm.showMore
          },
          on: { loadMore: _vm.loadMore }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }